import { orderCustomerStrictSchema } from "shared";
import { toFormikSchema } from "client-lib";

export const formikCartOrderSchema = toFormikSchema(orderCustomerStrictSchema);
